module.exports = require('react-router-config')
